import React, { useEffect, useState } from "react";
import { Avatar, Modal } from "djinn-components";
import axios from "../../utils/axios";
import { toast } from "react-toastify";
import { SubscriptionModel } from "../../types/api";
import { imagePath } from "../../utils/urls";
import ChoosePlanForm from "../Forms/ChoosePlanForm";
import { useSearchParams } from "react-router-dom";

const ManageAccountSubscriptions: React.FC<any> = () => {
  const [searchParams] = useSearchParams();

  const [subscriptions, setSubscriptions] = useState<SubscriptionModel[]>([]);
  const [subscriptionsLoading, setSubscriptionsLoading] = useState(true);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [showUpgradeForProject, setShowUpgradeForProject] = useState<
    string | null
  >(searchParams.get("choose-plan"));
  const getSubscriptions = async () => {
    try {
      const { data } = await axios.get("account/subscriptions");
      setSubscriptions(data);
      setSubscriptionsLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    getSubscriptions();
  }, []);

  const pushToStripeDashboard = async () => {
    setDashboardLoading(true);
    try {
      const { data } = await axios.get("stripe/create-portal-link");
      window.location.replace(data.url);
    } catch (error) {
      toast("Failed to load account details please try again later", {
        type: "error",
      });
    }
    setDashboardLoading(false);
  };

  const subscriptionClick = async (subscription: SubscriptionModel) => {
    if (subscription.id && !dashboardLoading) {
      await pushToStripeDashboard();
      return;
    }

    setShowUpgradeForProject(subscription.site_id);
  };

  return (
    <div className="max-w-5xl mx-auto">
      <div className="w-full mt-10">
        <table
          className="table-auto border-separate mr-0 w-full"
          style={{ borderSpacing: "0 1.2rem" }}
        >
          <thead className="opacity-100 bg-opacity-100">
            <tr>
              <td className="text-left text-md leading-4 font-large text-white tracking-wider opacity-100 bg-opacity-100 pl-14">
                Project
              </td>
              <td className="text-left text-md leading-4 font-large text-white tracking-wider">
                Subscription
              </td>
              <td className="text-left text-md leading-4 font-large text-white tracking-wider">
                Ends At
              </td>
              <td className="text-left text-md leading-4 font-large text-white tracking-wider">
                Renews At
              </td>
              <td className="px-6 lg:w-10 w-12" width="5%"></td>
            </tr>
          </thead>

          <tbody className="max-h-124 w-full">
            {subscriptions.map((subscription, index) => (
              <tr
                className={
                  "bg-gray-700 bg-opacity-50 rounded-full mb-6 h-12 pl-6 overflow-hidden w-full"
                }
                key={index}
              >
                <td className="whitespace-no-wrap rounded-l-full text-sm leading-5 font-regular text-white opacity-75 pl-1">
                  <div className="flex items-center justify-start">
                    <Avatar
                      img={imagePath(subscription.site_icon)}
                      text={subscription.site_name}
                    />
                    <span className="ml-3">{subscription.site_name}</span>
                  </div>
                </td>
                <td className="whitespace-no-wrap text-sm font-light leading-5 text-gray-400 opacity-75 capitalize">
                  {subscription.type}{" "}
                  {subscription.duration && (
                    <strong className="font-semibold opacity-1 text-white">
                      ({subscription.duration})
                    </strong>
                  )}
                  {subscription.type !== "none" && !subscription.id && (
                    <strong className="font-semibold opacity-1 text-white">
                      (Beta Promo)
                    </strong>
                  )}
                </td>
                <td className="whitespace-no-wrap text-sm font-light leading-5 text-white opacity-50 ">
                  {subscription.cancel_at_period_end ||
                  subscription.cancel_at ? (
                    <>
                      {new Date(
                        subscription.cancel_at ??
                          subscription.current_period_end!
                      ).toLocaleDateString()}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td className="whitespace-no-wrap text-sm font-light leading-5 text-gray-450 opacity-75">
                  {!subscription.cancel_at_period_end &&
                  subscription.current_period_end ? (
                    <>
                      {new Date(
                        subscription.current_period_end
                      ).toLocaleDateString()}{" "}
                      {subscription.renew_price && (
                        <span className="text-white font-medium">
                          (£{subscription.renew_price / 100})
                        </span>
                      )}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td width="12%" className="rounded-r-full">
                  <button
                    type="button"
                    tabIndex={0}
                    className="block h-5 w-full cursor-pointer text-gray-400 hover:text-white text-sm font-bold"
                    onClick={() => subscriptionClick(subscription)}
                  >
                    {subscription.id && "MANAGE"}
                    {!subscription.id && " Choose Plan"}
                  </button>
                </td>
              </tr>
            ))}

            {subscriptionsLoading && (
              <tr>
                <td className="p-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-400">
                  Loading Subscriptions...
                </td>
                <td className="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-400"></td>
                <td className="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-400"></td>
                <td className="px-6 py-4 whitespace-no-wrap text-right text-sm leading-5 font-medium"></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal
        shown={showUpgradeForProject !== null && !!subscriptions.length}
        onClose={() => setShowUpgradeForProject(null)}
      >
        {showUpgradeForProject && (
          <ChoosePlanForm siteId={showUpgradeForProject} />
        )}
      </Modal>
    </div>
  );
};

export default ManageAccountSubscriptions;
